var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"title-badge-container",class:_vm.clazzContainer},[_c('label',{staticClass:"title-badge",class:_vm.clazz},[_vm._v(" "+_vm._s(_vm.titleText)+" "),_c('b-badge',[_vm._v(_vm._s(_vm.badgeText))])],1),_c('div',{staticClass:"extra-content"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }